import { useEffect } from "react";
import { useCockpitStore } from "./store.js";
import { applyResolvedTheme, resolveTheme } from "./theme.js";

export const useThemeController = () => {
  const preference = useCockpitStore((state) => state.theme);
  const setResolvedTheme = useCockpitStore((state) => state.setResolvedTheme);

  useEffect(() => {
    const media = typeof window.matchMedia === "function"
      ? window.matchMedia("(prefers-color-scheme: light)")
      : null;
    const apply = () => {
      const resolvedTheme = resolveTheme(preference, media?.matches ?? false);
      applyResolvedTheme(resolvedTheme);
      setResolvedTheme(resolvedTheme);
    };

    apply();
    if (preference !== "system" || !media) return;
    media.addEventListener("change", apply);
    return () => media.removeEventListener("change", apply);
  }, [preference, setResolvedTheme]);
};
